import EventTitle from "./EventTitle";
export default EventTitle;
